import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MixedSchema } from '@principle-theorem/editor';
import { SystemTemplateSelectorsComponent } from '@principle-theorem/ng-principle-shared';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import {
  IPatient,
  IResolvedTemplateWithName,
  ITemplateDefinitionWithName,
  SystemTemplate,
} from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';

@Component({
  selector: 'pr-referral-patient-letter-sidebar',
  imports: [
    NgCommonModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    SystemTemplateSelectorsComponent,
  ],
  templateUrl: './referral-patient-letter-sidebar.component.html',
  styleUrl: './referral-patient-letter-sidebar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralPatientLetterSidebarComponent {
  patient = input.required<WithRef<IPatient>>();
  templates = input<ITemplateDefinitionWithName[]>([]);
  isSending = input<boolean>(false);
  isGenerating = input<boolean>(false);

  headerTemplateChange = output<MixedSchema | undefined>();
  footerTemplateChange = output<MixedSchema | undefined>();
  preview = output<void>();
  download = output<void>();
  send = output<void>();

  patientEmail = computed(() => this.patient().email);
  hasPatientEmail = computed(() => !!this.patientEmail());
  noEmailTooltip = computed(() =>
    !this.hasPatientEmail() ? 'Patient does not have an email address' : ''
  );

  printTemplates = computed(() =>
    this.templates().filter(
      (current) =>
        current.template === SystemTemplate.PrintHeader ||
        current.template === SystemTemplate.PrintFooter
    )
  );

  isActionDisabled = computed(() => this.isSending() || this.isGenerating());

  onTemplatesChange(templates: IResolvedTemplateWithName[]): void {
    const header = templates.find(
      (current) => current.template === SystemTemplate.PrintHeader
    );
    const footer = templates.find(
      (current) => current.template === SystemTemplate.PrintFooter
    );

    this.headerTemplateChange.emit(header?.content);
    this.footerTemplateChange.emit(footer?.content);
  }

  onPreview(): void {
    this.preview.emit();
  }

  onDownload(): void {
    this.download.emit();
  }

  onSend(): void {
    this.send.emit();
  }
}
